export const GET_BOOKINGS_STATE = "GET_BOOKINGS_STATE";
export const GET_LEASES_STATE = "GET_LEASES_STATE"
export const GET_RENEWALS_STATE = 'GET_RENEWALS_STATE'
export const GET_UNITS_STATE = 'GET_UNITS_STATE'
export const GET_UNITS_STATUS_STATE = 'GET_UNITS_STATUS_STATE'
export const GET_TENANTS_STATE = 'GET_TENANTS_STATE'
